import { createAction, props } from '@ngrx/store';
import { Paginator } from '../models/grid.model';

export const OrderingInit = createAction(
  '[Shared: Paginator]: Order Init',
  props<{ orderFieldOptions: string[]; selectedOrder: string }>()
);

export const SortingInit = createAction(
  '[Shared: Paginator]: Sorting Init',
  props<{ sortFieldOptions: string[]; selectedSortField: string }>()
);

export const ItemsPerPageChanged = createAction(
  '[Shared: Paginator]: Items Per Page Changed',
  props<{ itemsNumber: number }>()
);

export const OrderingChanged = createAction(
  '[Shared: Paginator]: Order Changed',
  props<{ selectedOrder: string }>()
);

export const SortingChanged = createAction(
  '[Shared: Paginator]: Sorting Changed',
  props<{ selectedSortField: string }>()
);

export const PagingChanged = createAction(
  '[Shared: Paginator]: Paging Changed',
  props<{ paginator: Paginator }>()
);

export const ResetPaging = createAction('[Shared: Paginator]: Reset Paging');

export const CountChanged = createAction(
  '[Shared: Paginator]: Count Changed',
  props<{ totalPages: any }>()
);
